<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>

<div class="row step1-errors" aria-live="polite" #focusableEleTop>
    <div class="col-24" *ngIf="IsErrorMesssage || hasError">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul role='list'>
                <li role='listitem' *ngFor="let error of errorMessage" aria-atomic="true">{{error}}</li>
                <li role='listitem' *ngFor="let error of ErrorMessages" aria-atomic="true">
                    <div [innerHtml]="error"></div>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="row" *ngIf="EnrollmentMethodError || SOAError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngIf="EnrollmentMethodError">
                    <button>
                        Please select a Enrollment Method.
                    </button>
                </li>
                <li *ngIf="SOAError">
                    <button>
                        Please select a Scope of Appointment.
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [for]="'agentId'" [label]="'Agent ID for this enrollment:'" [text]="agentUserName"
                (onValueChange)="dataEntryStep1.AgentName = $event" [validators]="[notBlankValidator]"
                [disabled]="isValidAgent">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <div *ngIf="!isValidAgent">
            <button class="button primary" (click)="onContinue()">Continue</button>
        </div>
        <div *ngIf="isValidAgent">
            <button class="button primary" (click)="onChangeAgentID()">Change Agent ID</button>
        </div>
    </div>
</div>
<div *ngIf="isValidAgent">
    <div class="row">
        <div class="col-8">
            <div class="bottom-20">
                <ValidatedDropDown class="wide" [selectedValue]="planstate" [label]="'Select the applicant’s state:'"
                    [disabled]="disabled" (onValueChange)="updateAgentGroup($event)" [options]="states">
                </ValidatedDropDown>
            </div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <!--<ValidatedDateTextField [label]="'Date of Receipt:'"
                                                id="dateofReceipt "
                                                [date]="dataEntryStep1.DateofReceipt"
                                                (onDateChange)="dataEntryStep1.DateofReceipt = $event"
                                                [validators]="[validatedDate,notBlankValidator]">
                        </ValidatedDateTextField>-->
                    <JQDatePicker [for]="DateOfReceipt" [label]="'Date of Receipt:'" id="DateofReceipt" [selectedDate]="dataEntryStep1.DateofReceipt"
                        (elementClicked)="dataEntryStep1.DateofReceipt = $event">
                    </JQDatePicker>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Select Enrollment Type:'" [options]="optionrbConactType"
                        [selectedValue]="selFaxContactType" (onValueChange)="dataEntryStep1.DataSource = $event"
                        [radioGroupName]="'ContactType'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <!--<div class="row" >
                <div class="col-12">
                    <div class="bottom-20">
                        <label>Group Name</label>
                            <jqxDropDownButton #myDropDownButton [width]="390" [height]="40" >
                                <div>
                                    <jqxGrid #myGrid (onRowselect)="myGridOnRowSelect($event)" [height]="350"
                                             [width]="1110" [source]="dataAdapter" [columns]="columns" [ready]="ready" [columnsheight]="50"
                                             [filterable]="true" [showfilterrow]="true" >
                                    </jqxGrid>
                                </div>
                            </jqxDropDownButton>

                        <p *ngIf="noGrpPlan">An enrollment cannot be entered as there is no active Group plans for this State</p>

                    </div>
                </div>

        </div>-->

        <div class="row">
            <div class="col-12">
                <groupplan [enrollmentDrugViewModel]="enrollment"
                           (focusSubmit)="setFocusToSubmitBtn()"></groupplan>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button #submitBtn class="button primary" (click)="formSubmit()">Submit</button>
            </div>
        </div>
    </div>
</div>